import React, { useMemo } from "react";
import AuthorCard from "./AuthorCard";
import Pagination from "./Pagination";

const AuthorList = ({
  auteurs,
  searchTerm,
  isGridView,
  currentPage,
  itemsPerPage,
  emptyComponent,
  onPageChange,
  editAuthor,
  deleteAuthor,
}) => {
  // Filter authors based on search term
  const filteredAuteurs = useMemo(() => {
    if (!searchTerm) return auteurs;

    const lowercasedTerm = searchTerm.toLowerCase();

    return auteurs.filter(
      (auteur) =>
        auteur.first_name.toLowerCase().includes(lowercasedTerm) ||
        auteur.last_name.toLowerCase().includes(lowercasedTerm) ||
        (auteur.email_user &&
          auteur.email_user.toLowerCase().includes(lowercasedTerm))
    );
  }, [auteurs, searchTerm]);

  // Paginate
  const paginatedAuteurs = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredAuteurs.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredAuteurs, currentPage, itemsPerPage]);

  // Calculate total pages
  const totalPages = Math.ceil(filteredAuteurs.length / itemsPerPage);

  // If no authors to display, show empty state
  if (filteredAuteurs.length === 0) {
    return emptyComponent;
  }

  return (
    <div>
      <div
        className={`mb-6 grid gap-4 ${
          isGridView
            ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
            : "grid-cols-1"
        }`}
      >
        {paginatedAuteurs.map((auteur) => (
          <AuthorCard
            key={auteur.id_aut}
            author={auteur}
            isGridView={isGridView}
            onEdit={() => editAuthor(auteur)}
            onDelete={() => deleteAuthor(auteur)}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default AuthorList;
